import React from "react";

export default function Translation(props) {
	const { uuid, body, user, datetime, language, transcript = false } = props;

	const date = typeof datetime === "string" ? new Date(datetime) : datetime;
	let datestr = "";
	try {
		datestr = date.toLocaleString([], {
			hour: "2-digit",
			minute: "2-digit",
		});
	} catch {}

	const bodystr = body.toString().replaceAll("\n", "<br />");
	const css = transcript ? "" : "px-3 py-2";

	return (
		<li className={`mb-3 chat-message ${css} rounded-sm`} id={uuid}>
			<div className="d-flex justify-content-between">
				<h6 className="font-weight-bold m-0 text-truncate">
					{user.name}[{language}]
				</h6>
				<span className="text-muted small d-block pl-3 text-right text-nowrap">
					{datestr}
				</span>
			</div>
			<span dangerouslySetInnerHTML={{ __html: bodystr }} />
		</li>
	);
}
